<template>
    <div class="uk-accordion uk-margin-top">
        <h3 class="uk-accordion-title">
            Contact Info
        </h3>
        <div class="uk-accordion-content lam-tight">
            <contact-info-section
                v-if="showEmails"
                :owner-type="ownerType"
                :owner-id="ownerId"
                type="email"
                title="Email Addresses"
                :editable="editable"
                :records="email_addresses"
                :can-add="canAdd"
            />

            <contact-info-section
                v-if="showPhones"
                :owner-type="ownerType"
                :owner-id="ownerId"
                type="mobile"
                title="Phone & Mobile Numbers"
                :editable="editable"
                :records="phone_numbers"
                :can-add="canAdd"
            />

            <contact-info-section
                v-if="showUrls"
                :owner-type="ownerType"
                :owner-id="ownerId"
                type="url"
                title="Websites"
                :editable="editable"
                :records="urls"
                :can-add="canAdd"
            />
        </div>
    </div>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex"

import ContactInfoSection from "./ContactInfoSection"

export default {
    components: {
        ContactInfoSection
    },
    methods: {
        contact_methods () {
            const methods = Array.from(arguments)
            return Object.values(this.raw_contact_method_records).filter(contact_method => {
                return !!contact_method.owner_type && (contact_method.owner_type.replace(/\\+/g, ".") === this.ownerType) && (contact_method.owner_id === this.ownerId) && (methods.indexOf(contact_method.method) >= 0)
            })
        }
    },
    computed: {
        ...mapGetters(["entity_records"]),
        raw_contact_method_records () {
            return this.entity_records("contact_method")
        },
        email_addresses () {
            return this.contact_methods("email")
        },
        phone_numbers () {
            return this.contact_methods("phone", "mobile")
        },
        urls () {
            return this.contact_methods("url")
        }
    },
    props: {
        entity: {
            type: String,
            required: true
        },
        ownerId: {
            type: Number,
            required: true
        },
        ownerType: {
            type: String,
            required: true
        },
        editable: {
            type: Boolean,
            default: true
        },
        canAdd: {
            type: Boolean,
            default: true
        },
        showEmails: {
            type: Boolean,
            default: true
        },
        showPhones: {
            type: Boolean,
            default: true
        },
        showUrls: {
            type: Boolean,
            default: true
        }
    }
}
</script>
